import { __awaiter, __generator } from "tslib";
import { getUserStorageItem, } from '@office-start/user-storage-service';
export var executeWebStorageGetUserItem = function (_a) {
    var storageKey = _a.storageKey, userStorageOptions = _a.userStorageOptions;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getUserStorageItem(storageKey, userStorageOptions)];
                case 1:
                    data = _b.sent();
                    if (!data) {
                        return [2 /*return*/, {
                                result: undefined,
                                fromPersistence: false,
                            }];
                    }
                    return [2 /*return*/, {
                            result: data,
                            fromPersistence: true,
                        }];
            }
        });
    });
};
//# sourceMappingURL=executeGetUserStorageItem.js.map